import {CSSProperties, FC} from 'react';


export interface IIconSecondaryCheckNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSecondaryCheckNissan: FC<IIconSecondaryCheckNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M17.725 8.26A.841.841 0 0 0 17.12 8a.841.841 0 0 0-.606.26L10.15 14.83 7.48 12.064a.854.854 0 0 0-.847-.218.888.888 0 0 0-.606.647.918.918 0 0 0 .24.865l3.28 3.382c.16.166.378.26.605.26a.841.841 0 0 0 .607-.26l6.967-7.185A.893.893 0 0 0 18 8.908c0-.246-.1-.48-.275-.648Z" clipRule="evenodd" />
        </svg>
    );
};
